import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { Badge } from '@mui/material'
import Select from '@mui/material/Select'
import { css, styled } from '@mui/material/styles'
import { colors } from '@theme/variables'

export const SearchResultsFilterWrapper = styled('button')`
  background: none;
  border: none;
  padding: 0;
  width: 100%;
`

interface SearchResultsFilterSelectProps {
  $open: boolean
}

export const NewCountAssetsBadge = styled(Badge)`
  height: 18px;
  min-width: 10px;
  color: #fff;
  background-color: #e22758;
  padding: 6px;
  border-radius: 50px;
  font-size: 11px;
  font-weight: 400;
  display: flex;
  margin-left: 10px;
  align-items: center;
  justify-content: center;
`

export const SearchResultsFilterSelect = styled(Select)<SearchResultsFilterSelectProps>`
  background: ${colors.white};
  height: 30px;
  ${({ $width }: { $width?: string }) =>
    $width
      ? css`
          width: ${$width};
        `
      : ''}

  .MuiSelect-select {
    min-height: auto;
  }

  .MuiOutlinedInput-notchedOutline {
    border-color: ${colors.lightGrey};
  }

  &:not(.Mui-disabled) {
    &:hover.Mui-focused .MuiOutlinedInput-notchedOutline {
      border-color: ${colors.primaryDark};
    }
    &:hover .MuiOutlinedInput-notchedOutline {
      border-color: ${colors.primaryDark};
    }
    &.Mui-focused .MuiOutlinedInput-notchedOutline {
      border: 1px solid ${({ $open }: { $open?: boolean }) => ($open ? colors.primaryDark : colors.lightGrey)};
    }
  }

  & + & {
    margin-left: 12px;
  }
`

export const StyledExpandMoreIcon = styled(ExpandMoreIcon)`
  color: ${colors.bodyText};
`
